import styled, { css } from "react-emotion";
import { isMobile } from "components/ReactUtils/mobileDetect.js";
import { observer } from "mobx-react";
import { components, Creatable } from "react-select";
import theme from "components/theme";
import React, { Component } from "react";
import SVG from "react-inlinesvg";

const arrowUp = require("shapes/icons/arrowUp.svg");

const IndicatorSeparator = () => null;

const DropdownIndicator = () => null;

const Control = ({ children, ...props }) => (
  <components.Control {...props} className="react-select_control">
    {children}
  </components.Control>
);

const Input = ({ children, ...props }) => (
  <components.Input {...props} className="react-select_input">
    {children}
  </components.Input>
);

class InputSelect extends Component {
  onNewSelectChange = o => {
    const { store, name } = this.props;
    if (o) {
      store.set(name, o.value);
    } else {
      store.set(name, null);
    }
  };

  onBlur = e => {
    const { store, name } = this.props;

    const { value } = e.target;
    if (value) {
      store.set(name, value);
    }
  };

  onChange = event => {
    const {
      // name,
      store,
      onChange,
    } = this.props;

    store.set(event.target.name, event.target.value);

    onChange && onChange(event);

    return true;
  };

  emotionStyles = {
    root: css`
      select::-ms-expand {
        display: none;
      }

      .select-container select {
        appearance: none;
      }
    `,
    icon: css`
      position: absolute;
      height: 25px;
      right: 11px;
      top: 32px;

      svg {
        transform: rotate(180deg);
      }
    `,
  };

  render() {
    const { emotionStyles } = this;
    const {
      name,
      label,
      formGroupAdd,
      additionalSelects = [],
      labelWidth = "",
      inputWidth = "",
      size = "md",
      darkBg,
      className,
      inputGroup = false,
      mobileGroup = false,
      tall = false,
      svgArrow = false,
      store,
      options = [],
      newSelect = false,
    } = this.props;

    let inputEl = [{ name, options }, ...additionalSelects].map(({ name, options }, selectIndex) => (
      <div key={selectIndex.toString()}>
        {svgArrow && (
          <span className={emotionStyles.icon}>
            <span className={`svg ${theme.fonts.colors.primary}`}>
              <SVG src={arrowUp} />
            </span>
          </span>
        )}
        <select
          className="form-control"
          style={{
            display: additionalSelects.length > 0 ? "inline-block" : "block",
            width: `${additionalSelects.length > 0 ? 100 / (additionalSelects.length + 1) : 100}%`,
          }}
          name={name}
          value={store.get(name)}
          onChange={e => this.onChange(e, store, name)}
        >
          {options.map((option, i) => (
            <option key={i.toString()} value={option.value || option.label}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    ));

    if (newSelect) {
      inputEl = (
        <Creatable
          ref={ref => {
            this.select = ref;
          }}
          isClearable
          name={name}
          options={options}
          value={{ label: store.get(name), value: store.get(name) }}
          onChange={this.onNewSelectChange}
          onBlur={this.onBlur}
          placeholder=""
          formatCreateLabel={input => input}
          openMenuOnFocus
          openMenuOnClick={false}
          createOptionPosition="first"
          isSearchable
          noOptionsMessage={() => "Keine Ergebnisse für"}
          autoFocus={false}
          styles={{
            control: base => ({
              ...base,
              border: `1px solid ${theme.colors.gray}`,
            }),
          }}
          data={store && store.data}
          theme={baseTheme => ({
            ...baseTheme,
            spacing: {
              ...baseTheme.spacing,
              controlHeight: 45,
              baseUnit: 2,
              menuGutter: 4,
            },
            colors: {
              ...baseTheme.colors,
              primary: theme.colors.primary,
              primary25: theme.colors.primarySecond,
            },
          })}
          components={{ DropdownIndicator, IndicatorSeparator, Control, Input }}
        />
      );
    }

    return (
      <div
        data={store && store.data}
        className={[
          className,
          "form-group",
          "inputText",
          darkBg && "darkBg",
          tall && "tall",
          // // focus && "focus",
          svgArrow ? emotionStyles.root : null,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[
            inputGroup && (mobileGroup || !isMobile()) && "input-group",
            "position-relative",
            `input-group-${size}`,
            "select-container",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {label && (
            <label className={`control-label ${labelWidth}`}>
              <span className="labelText">{label || name}</span>
            </label>
          )}

          {!inputGroup && <div className={inputWidth}>{inputEl}</div>}
          {inputGroup && inputEl}

          {formGroupAdd}
        </div>
      </div>
    );
  }
}

InputSelect = observer(InputSelect);
InputSelect = styled(InputSelect)`
  .control-label span {
    font-weight: normal;
  }
`;

export default InputSelect;
